/**
 * カレンダー
 */
!function(){
	$(function(){
		var $button = $('.js-calnedar-modal-toggle');
		var $modal  = $('#modalCalendar');
		if($button.length !== 0 && $modal.length !== 0){
			$button.on("click",function(){
				$modal.fadeToggle();
				return false;
			});
		}
	});
}();